import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InboxRowCard from "../cards/InboxRowCard";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';
import Box from "@mui/material/Box";

import isUserLoggedIn from "../helpers/redirect";
import { useNavigate, useLocation } from "react-router-dom";

import { useAuth } from "../../../auth";

const Inbox = () => {
  const [clientList, setClientList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, userType, logout } = useAuth();

  // Fetch Clients using the same API as chat section
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(`https://integrations.uwc.world/api/offline_chat/get_all_chats_for_expert/${currentUser?.UserId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          if (data?.code === 200) {
            setClientList(data.data);
            setIsLoading(false);
          }
        } else {
          throw new Error("Failed to fetch clients");
        }
      } catch (error) {
        console.error("Error:", error);
        setIsLoading(false);
      }
    };

    if (currentUser?.UserId) {
      fetchClients();
    }
  }, [currentUser?.UserId]);

  return (
    <div
      className="InboxWidget border  Widget rounded-4"
      style={{ background: "#FFFFFF" }}
    >
      <div className="d-flex border-bottom justify-content-between p-3 align-items-center Widget--Header">
        <h6 className="font-inter fs-5">Inbox</h6>
        {clientList?.length > 0 && (
          <Link
            to="/expert/chat"
            className="text-decoration-none d-flex align-items-center gap-2"
          >
            <p className="font-inter" style={{ color: "var(--primary-base-color)" }}>
              View All{" "}
            </p>
            <ArrowRightAltIcon style={{ color: "var(--primary-base-color)" }} />
          </Link>
        )}
      </div>
      <div className="InboxWidget--Content">
        {
          isLoading ? (
          <div
          style={{
            display: "flex", flexDirection:"column", gap:"10px", margin: "5px 0px 5px 10px"
          }}
          >
          {Array.from(new Array(4)).map((_, index) => (
            <Box sx={{ pt: 0.5, display:"flex", gap:"10px" }}>
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" sx={{ fontSize: '1rem', width: "50%" }} />
            </Box>
          ))}
            
          </div>
          ) :(clientList?.length === 0 ? (
          <p style={{ margin: "0 auto 20px 0", textAlign: "center" }}>
            No Inbox Data
          </p>
        ) : (
          clientList
            ?.slice(0, 4)
            .map((item) => (
              <InboxRowCard
                key={item.to_id}
                img={item.user_details?.image}
                name={item.user_details?.name}
                messageType={item.messages?.[0]?.message_type || "text"}
                message={item.messages?.[0]?.message || "No messages yet"}
                unreadMessages={item.unread_count || 0}
              />
            ))
        ))}
      </div>
    </div>
  );
};

export default Inbox;
